export const endpoints = {
  marketing: {
    pricing: 'marketing/pricing',
    contact: 'marketing/contact',
  },
  legal: {
    documents: 'legal/documents',
    document: (kind: string) => `legal/documents/${kind}`,
  },
};
